module.exports = __webpack_public_path__ + "img/soilder.fb599650.jpg";